export const convertErrorObject = (errors: Record<string, string[]>): any => {
	const result: any = {};

	Object.entries(errors).forEach(([path, messages]) => {
		const keys = path.split('.');
		const lastKey = keys.pop()!;
		const nested = keys.reduce((acc: any, key) => {
			const index = Number(key);
			if (!isNaN(index) && key.trim() !== '') {
				acc[index] = acc[index] || {};
				return acc[index];
			} else {
				acc[key] = acc[key] || {};
				return acc[key];
			}
		}, result);

		nested[lastKey] = { _errors: messages };
	});

	return result;
};